import ReactDOM from 'react-dom'

import { parseJSONFromScript } from '../shared/parseJSONFromScript'
import Canvas from './components/Canvas'
import { SettingsSmall, SettingsSmallDark, SettingsSmallGeo, SettingsSmallGeoDark } from './constants/settings'
import Treemap from './treemap'
import { MapSubtypeId, MapTypeId, PerfData, ScaleId } from './types'
import * as mapUtils from './utils'

const CANVAS_WIDTH = 400
const CANVAS_HEIGHT_GEO = 235
const CANVAS_HEIGHT = 300
const CANVAS_HEIGHT_NEW = 368

async function renderTreemaps(props: { perfDataSec: PerfData; perfDataGeo: PerfData; cacheBuster: number }) {
  let precomputedData
  try {
    precomputedData = await mapUtils.fetchBaseData(
      FinvizSettings.hasRedesignEnabled ? 'hp_redesign.json' : 'hp.json',
      props.cacheBuster
    )
  } catch {
    return
  }
  const isDark = document.documentElement.classList.contains('dark')

  if (props.perfDataSec) {
    const initData = mapUtils.getMapData(precomputedData.sec, props.perfDataSec)
    const treemap = new Treemap({
      data: initData,
      width: CANVAS_WIDTH,
      height: FinvizSettings.hasRedesignEnabled ? CANVAS_HEIGHT_NEW : CANVAS_HEIGHT,
      scaleId: ScaleId.DayPerf,
      countIndustryPerf: false,
      countSectorPerf: true,
      settings: isDark ? SettingsSmallDark : SettingsSmall,
      type: MapTypeId.Sector,
      subtype: MapSubtypeId.DayPerf,
      isSmall: true,
      zoomLevels: [1],
    })

    window.FinvizIndexSecMap = treemap

    ReactDOM.render(
      <Canvas
        treemap={treemap}
        scale={{ id: ScaleId.DayPerf, name: '', tooltip: null }}
        hover={false}
        legend={false}
        zoom={false}
        alt="S&P 500 Map"
      />,
      document.getElementById('treemap-small')
    )
  }

  if (props.perfDataGeo) {
    const initData = mapUtils.getMapData(precomputedData.geo, props.perfDataGeo)
    const treemap = new Treemap({
      data: initData,
      width: CANVAS_WIDTH,
      height: CANVAS_HEIGHT_GEO,
      scaleId: ScaleId.DayPerf,
      countIndustryPerf: true,
      countSectorPerf: false,
      settings: isDark ? SettingsSmallGeoDark : SettingsSmallGeo,
      type: MapTypeId.World,
      subtype: MapSubtypeId.DayPerf,
      isSmall: true,
      zoomLevels: [1],
    })

    window.FinvizIndexGeoMap = treemap

    ReactDOM.render(
      <Canvas
        treemap={treemap}
        scale={{ id: ScaleId.DayPerf, name: '', tooltip: null }}
        hover={false}
        legend={false}
        zoom={false}
        alt="World Map"
      />,
      document.getElementById('treemap-small-geo')
    )
  }
}

const mapProps = parseJSONFromScript<{ perfDataSec: PerfData; perfDataGeo: PerfData; cacheBuster: number }>('map-data')
if (mapProps) renderTreemaps(mapProps)
